export default {
  viewBox: "0 0 24 25",
  html: "<path fill-rule=\"evenodd\" d=\"M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6.873 11.25 4.192-4.192L12 6l-6 6 6 6 1.057-1.058-4.184-4.192H18v-1.5z\"/>"
};